module.exports = __webpack_public_path__ + "img/cps_preview_tr.265e4ea3.png";